import * as React from 'react';
import { InlineText2, Input } from '@cian/ui-kit';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NameInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var handleChangeValue = function handleChangeValue(_, value) {
    var newValue = value.replace(/[^\w\s\-а-яА-ЯёЁ]/g, '');
    if (newValue.length > 40) {
      return;
    }
    onChange(newValue);
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['title'],
      children: /*#__PURE__*/_jsx(InlineText2, {
        children: "\u0418\u043C\u044F \u0438 \u0444\u0430\u043C\u0438\u043B\u0438\u044F"
      })
    }), /*#__PURE__*/_jsx(Input, {
      type: "text",
      placeholder: "\u0418\u0432\u0430\u043D \u0418\u0432\u0430\u043D\u043E\u0432",
      value: value,
      onChange: handleChangeValue,
      size: "M"
    })]
  });
}